import lang from "translations";

export const MonthlySaleReportColumns = [
  {
    key: "venueId",
    text: lang.id,
    align: "left",
    nowrap: true,
  },
  {
    key: "venueName",
    text: lang.venueName,
  },
  {
    key: "country",
    text: lang.country,
  },
  {
    key: "currency",
    text: lang.currency,
  },
  {
    key: "subscriptionPlanName",
    text: lang.subscriptionPlanName,
  },
  {
    key: "subscriptionCustomerId",
    text: lang.subscriptionCustomerId,
  },
  {
    key: "businessAddress",
    text: lang.businessAddress,
  },
  {
    key: "businessContactNumber",
    text: lang.businessContactNumber,
  },
  {
    key: "devices",
    text: lang.devices,
  },
  {
    key: "sales",
    text: lang.sale,
    align: "right",
  }
];
